export default "__VITE_ASSET__DKK98gdR__"